<template>
    <div class = "login_top">
        <div class = "top_center clear">
            <a class = "f1">
                <img @click="goIndex()" src="../../assets/image/regLogin/logo.png" alt="">
            </a>
            <p class = "top_line f1"></p>
            <p class = "top_title f1">互联网+财税平台，全面实现信息化</p>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        goIndex(){
            this.$router.push({path:'/index'})
        }
    },
}
</script>
<style lang="scss" scoped>
.login_top{
    padding-top: 20px;
    padding-bottom: 20px;
    .top_center{
        width: 1160px;
        margin: 0px auto;
        a{
            img{
                display: block;
                height: 100px;
                cursor: pointer;
            }
        }
        .top_line{
            border-left: 3px solid #ff8f3d;
            height: 80px;
            margin-left: 50px;
            margin-right: 50px;
        }
        .top_title{
            font-size: 34px;
            font-weight: bold;
            color: #787878;
            line-height: 80px;
        }
    }
}
.f1{
    float: left;
}
.clear:after{ clear:both;content:'';display:block;width: 0;height: 0;visibility:hidden;}
</style>




// WEBPACK FOOTER //
// src/components/registerLogin/rhead.vue